















































































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

@Component({})
export default class WordCloud extends Vue {

  private target: string = '';
  private replacement: string = '';

  private isSaving: boolean = false;
  private isLoading: boolean = true;

  private words: any[] = [];

  protected async created() {
    this.isLoading = true;
    try {
      const response = await axios.get('words');
      this.words = response.data;
    } catch (e) {
      this.words = [];
      this.$notify({type: 'error', text: e.message});
    }
    this.isLoading = false;
  }

  protected async addWord() {
    if (this.wordCloudContains(this.target)) {
      this.$notify({type: 'warning', text: `'${this.target}' already exists in the word cloud.`});
      this.target = this.replacement = '';
      return;
    }
    await this.save(
      this.words.concat([{target: this.target, replacement: this.replacement}])
    );
    this.target = this.replacement = '';
    this.$notify({type: 'success', text: 'The word has been added.'});
  }

  protected async deleteWord(word) {
    await this.save(
      this.words.filter((it) => it !== word)
    );
    this.$notify({type: 'success', text: 'The word has been deleted.'});
  }

  private wordCloudContains(target) {
    for (const word of this.words) {
      if (target === word.target) {
        return true;
      }
    }
    return false;
  }

  private async save(words) {
    this.isSaving = true;
    try {
      await axios.post('words', words);
      this.words = words;
    } catch (e) {
      this.$notify({type: 'error', text: e.message});
    }
    this.isSaving = false;
  }
}
